// todo: replace once type generator is in UAT.
export type AngusIntegrationSettingsType = {
  baseUrl: string;
  authUrl: string;
};

// todo: replace once type generator is in UAT.
export type AngusChannelIntegrationSettingsType = {
  baseUrl?: string;
  authUrl?: string;
  name?: string;
  subtitle?: string;
  description?: string;
  supportEmail?: string;
  client_id: string;
  client_secret: string;
  scope: string;
  grant_type: string;
  propertyId: string;
  buildingId?: string;
};

// message from the Angus API
export const ANGUS_WORK_ORDER_NOT_FOUND = 'Work Order not found';

export type AngusWorkOrderDataType = {
  _id: string; // '8001917';
  floor: string; // '20';
  suite: string; // 'N/A';
  status: string; // 'Complete';
  tenantId: string; // 'FAA80A9D-27F8-4EA2-8F80-93F235F4BE10';
  buildingId: string; // '3E26D25F-2789-4DBC-A64E-E2B4CF13FE66';
  locationId: string; // '38763EE3-8279-4CA6-9D58-6C5528849424';
  propertyId: string; // 'A30248F1-8D1A-4993-BEE6-1413B0E4265C';
  statusCode: number; // 14;
  tenantName: string; // 'Australian Financial Complaints Authority Ltd';
  attachments: any; // null;
  description: string; // 'Please remove and....';
  requestDate: string; // '2021-05-24T17:00:00';
  requesterId: string; // '6DDEA1A1-23EF-45AB-8987-C4A4A67EE03B';
  buildingName: string; // '680 George Street';
  propertyName: string; // '680 George Street';
  requestTypeId: string; // 'E4704EFE-FF80-41C3-9412-92392E8BF4A6';
  requesterName: string; // 'Cindy Chia';
  locationRefNum: string; // '38763EE3-8279-4CA6-9D58-6C5528849424';
  requesterRefNum: string; // '6DDEA1A1-23EF-45AB-8987-C4A4A67EE03B';
  workOrderHistory: AngusWorkOrderDataType[];
  requestTypeRefNum: string; // 'E4704EFE-FF80-41C3-9412-92392E8BF4A6';
  requestTypeDescription: string; // 'CLEANING RECYCLE -  ELECTRONICS & COMPUTERS ';
};

export type AngusInteractionType = {
  _id: string;
  _updated: Date;
  status: string;
  data: {
    _AngusServiceRequest: AngusWorkOrderDataType;
  };
  userId: string;
  analyticsId: string;
  contentId: string;
  channelId: string;
  channelIntegrationId: string;
  integrationKey: string;
  channelName: string;
  channelProfileName: string;
};
